import API from '@/api';

export default {
    namespaced: true,
    state: {
        items: [],
        filters: {
            city: {
                lng: null,
                lat: null,
                value: null,
            },
            activityType: null,
            date: null,
            campaign: null
        },
        filterValues: {
            activityType: null,
        },
        meta: {},
        pagination: {},
        totalItemsAvailable: null,
        nextpage: null,
        noresults: false,
    },
    getters: {

    },
    actions: {
        getProducts({state, commit}, {partner = undefined, campaign = undefined} = {partner:false, campaign: undefined}) {

            return new Promise((resolve) => {
                if(state.items.length === 0 || state.noresults) {
                    const cleanFilters = {};


                    // only filter if there are results
                    if(!state.noresults) {
                        const filtersToParams = {
                            lng: state.filters.city?.lng,
                            lat: state.filters.city?.lat,
                            type: state.filters.activityType,
                            date: state.filters.date,
                            include: ['locations']
                        };

                        if (typeof partner !== "undefined" && partner === true) {
                            filtersToParams['target_audience'] = 2;
                        }

                        if (typeof campaign !== "undefined") {
                            filtersToParams['campaign'] = campaign;
                        }

                        Object.entries(filtersToParams).forEach((item) => {
                            if(item[1]) {
                                cleanFilters[item[0]] = item[1];
                            }
                        });
                    }

                    API.ijstijd.getProducts(cleanFilters, partner ? 200 : 24).then((response) => {
                        commit('removeAllProducts');
                        commit('reloadProducts', {
                            meta: response.data.meta,
                            items: response.data.products
                        });

                        setTimeout(() => {
                            resolve(response.data.products);
                        }, 0);
                    }, () => {

                    });
                }
            });
        },
        getMoreProducts({state, commit}) {
            API.ijstijd.get(state.pagination.links.next)
                .then((response) => {
                    commit('addProducts', {
                        meta: response.data.meta,
                        items: response.data.products
                    });
                })
        },
        prefillFilters({commit, dispatch}, filters) {
            commit('saveFilters', Object.assign({}, filters));
        },
        setFilters({commit, dispatch}, filters) {
            commit('saveFilters', Object.assign({}, filters));
            commit('removeAllProducts');
            commit('resetNoResults');
        },

        partnerOrder(context, data) {
            return API.ijstijd.partnerorder(data, data.code.split('-')[0]);
        },
    },
    mutations: {
        reloadProducts(state, data) {
            state.items = data.items;
            state.meta = data.meta;
            state.filterValues.activityTypes = data.meta.type;
            state.pagination = data.meta.pagination;
            state.nextpage = data.meta.pagination.links.next;
            state.totalItemsAvailable = data.meta.pagination.total;

            if(state.items.length === 0 && !state.noresults) {
                state.noresults = true;
            }

            if(state.noresults) {
                state.totalItemsAvailable = 0;
            }
        },
        addProducts(state, data) {
            state.items = state.items.concat(data.items);
            state.pagination = data.meta.pagination;
            state.meta = data.meta;
            state.nextpage = data.meta.pagination.links.next;
        },
        removeAllProducts(state) {
            state.items = [];
            state.nextpage = null;
        },
        resetNoResults(state) {
            state.noresults = false;
        },
        saveFilters(state, filters) {
            state.filters = filters;
        }
    }
}
